/* esm.sh - use-sidecar@1.1.3/dist/es2015/env */
import{isNode as e}from"detect-node-es";var r={isNode:e,forceCache:!1};export{r as env};
//# sourceMappingURL=env.mjs.map